
export default function ContactHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/20d75e80d5e9b31ef3a4f69d53dbd8ca.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white">
        <p className="text-amber-400 text-sm font-medium tracking-wider uppercase mb-4">Reach Out</p>
        <h1 className="text-5xl md:text-7xl font-bold mb-6">
          Get In <strong>Touch</strong>
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
          Ready to transform your space? Contact <strong>Brushour</strong> today for a free quote on professional <strong>painting and decorating services</strong> across <strong>Hertfordshire</strong>
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="tel:07595037441"
            className="inline-flex items-center gap-3 px-8 py-4 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-phone-line text-xl"></i>
            </div>
            <span>Call 07595037441</span>
          </a>
          <a
            href="https://wa.me/447595037441"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-white hover:bg-beige-50 text-gray-800 font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl text-green-600"></i>
            </div>
            <span>WhatsApp Us</span>
          </a>
        </div>
      </div>
    </section>
  );
}
